"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.edit.title': 'Modifica Tutorial',
};
